import * as ui from "../../core/ui";
import guts from "./userDashboards.view";

var view = () => new ui.Pane({
    id: "ManageUsersDashboards",
    screenEntityType: "Dashboard",
    header: "ManageDashboardsButton",
    actions: [
        new ui.Button({
            id: "Close",
            label: "Close",
            bsc: "left"
        })
    ],
    components: [
        new ui.Pane({
            id: "EmployeeDashboardPane",
            screenEntityType: "Dashboard",
            classes: "pane-in-popup",
            header: "ManageDashboardsButton",
            components: guts()
        })
    ]
});

export default view;
